import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import EquipContainingLogForm from "./EquipContainingLogForm";

const ViewEquipContainingLog = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("ods_id", id);

    post(ApiURL.ods_listing_details, fd).then((res) => {
      if (res?.status === true) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  return (
    <>
      <h2>View Equip Containing Log</h2>
      <EquipContainingLogForm equipmentDetails={details.equipment} readOnly />
    </>
  );
};

export default ViewEquipContainingLog;
